var exports = {
  "X$": "x0a7806d5--6a93ac--pagination",
  "kI": "x0a7806d5--6a93ac--pages-list",
  "MY": "x0a7806d5--6a93ac--page",
};

module.exports = exports;
